var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    {
      on: {
        keydown: function($event) {
          _vm.scanMode !== null && _vm.scanMode
        }
      }
    },
    [
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "6", md: "9" } },
        [
          _c(
            "v-card",
            { staticClass: "mt-5" },
            [
              !_vm.swipeMode
                ? _c("v-card-title", { staticClass: "grey lighten-4 p-2" }, [
                    _c("h4", { staticClass: "m-0" }, [
                      _c("span", { staticClass: " error--text" }, [
                        _vm._v(" Reservation Total:")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "blue--text text--accent-4" }, [
                        _vm._v("$" + _vm._s(_vm.amount))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.swipeMode && !_vm.fullCharge
                ? _c("v-card-title", { staticClass: "grey lighten-4 p-2" }, [
                    _c(
                      "h5",
                      {
                        staticClass:
                          "m-0 font-weight-bold error--text text-break"
                      },
                      [
                        _vm._v(
                          "\n                        We are saving your card information and are not charging you at this time\n                    "
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "p-2" },
                [
                  _vm.reservation.is_seasonal &&
                  _vm.securitydeposit &&
                  !_vm.swipeMode &&
                  _vm.frontend_view_folder == "frontend.highcountryskiandtennis"
                    ? _c(
                        "span",
                        { staticClass: "mt-5 error--text  text-break" },
                        [
                          _vm._v(
                            "\n                        Please Enter Credit Card Information that is used as a security Deposit.\n                    "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  ((!_vm.securitydeposit &&
                    _vm.is_seasonal &&
                    _vm.frontend_view_folder ==
                      "frontend.highcountryskiandtennis") ||
                    !_vm.is_seasonal ||
                    (_vm.is_seasonal &&
                      _vm.frontend_view_folder !==
                        "frontend.highcountryskiandtennis")) &&
                  _vm.swipeMode
                    ? [
                        _c(
                          "div",
                          {
                            class:
                              _vm.is_seasonal && _vm.swipeMode
                                ? "error--text"
                                : "mt-5 error--text"
                          },
                          [
                            _vm._v(" Reservation Total: "),
                            _c(
                              "span",
                              { staticClass: "blue--text text--accent-4" },
                              [_vm._v("$" + _vm._s(_vm.amount))]
                            )
                          ]
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.securitydeposit &&
                  _vm.swipeMode &&
                  _vm.is_seasonal &&
                  _vm.frontend_view_folder == "frontend.highcountryskiandtennis"
                    ? [
                        _c("div", {}, [
                          _vm._v(" Total Rental: "),
                          _c(
                            "span",
                            { staticClass: "blue--text text--accent-4" },
                            [
                              _vm._v(
                                "$" +
                                  _vm._s(
                                    parseFloat(
                                      parseFloat(_vm.amount) -
                                        _vm.cost.deposit_total
                                    ).toFixed(2)
                                  )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "error--text" }, [
                          _vm._v(" Deposit: "),
                          _c(
                            "span",
                            { staticClass: "blue--text text--accent-4" },
                            [
                              _vm._v(
                                "$" +
                                  _vm._s(
                                    parseFloat(_vm.cost.deposit_total).toFixed(
                                      2
                                    )
                                  )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-5 error--text" }, [
                          _vm._v(" Total: "),
                          _c(
                            "span",
                            { staticClass: "blue--text text--accent-4" },
                            [
                              _vm._v(
                                "$" + _vm._s(parseFloat(_vm.amount).toFixed(2))
                              )
                            ]
                          )
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cash_pay_switch &&
                  _vm.reservation.is_from_kiosk == 1 &&
                    ((_vm.reservation.is_seasonal &&
                      _vm.seasonal_kiosk_cash_pay) ||
                      (!_vm.reservation.is_seasonal && _vm.kiosk_cash_pay))
                    ? [
                        _c(
                          "span",
                          { staticClass: "mt-5" },
                          [
                            _c("with-validation", {
                              attrs: {
                                context: _vm.self(),
                                field: "kiosk_cash_pay"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var bind = ref.bind
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-checkbox",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  "true-value": true,
                                                  "false-value": false
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "label",
                                                      fn: function() {
                                                        return [
                                                          _c("div", [
                                                            _vm._v(
                                                              "\n                                        I prefer to pay cash at the register\n                                    "
                                                            )
                                                          ])
                                                        ]
                                                      },
                                                      proxy: true
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              "v-checkbox",
                                              bind,
                                              false
                                            ),
                                            on
                                          )
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2208254026
                              )
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: " mt-4 mb-5" },
                    [
                      _vm.turn_off_swipe_kiosk
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: _vm.swipeButtonColor,
                                "data-activated": _vm.dataActivated
                              },
                              on: {
                                click: function($event) {
                                  return _vm.scanningMode()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                            Click here, and swipe your card\n                        "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("with-validation", {
                    attrs: { field: "cc" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var bind = ref.bind
                          var on = ref.on
                          return [
                            _c(
                              "v-text-field",
                              _vm._g(
                                _vm._b(
                                  {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: "NNNN NNNN NNNN NNNN",
                                        expression: "'NNNN NNNN NNNN NNNN'"
                                      }
                                    ],
                                    staticClass: "mt-1",
                                    attrs: {
                                      outlined: "",
                                      clearable: "",
                                      label: "Credit Card",
                                      type: "text"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "append",
                                          fn: function() {
                                            return [
                                              _c("img", {
                                                staticClass:
                                                  "d-none d-md-block",
                                                attrs: {
                                                  width: "130",
                                                  height: "24",
                                                  src: "/img/creditcards.png",
                                                  alt: ""
                                                }
                                              })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  "v-text-field",
                                  bind,
                                  false
                                ),
                                on
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    ref: "swipe-data",
                    staticClass: "mt-1",
                    staticStyle: { position: "absolute", right: "10000px" },
                    attrs: { name: "swipedata", type: "text" },
                    on: { keyup: _vm.scanKeyUp },
                    nativeOn: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.onEnter.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.swipeData,
                      callback: function($$v) {
                        _vm.swipeData = $$v
                      },
                      expression: "swipeData"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("with-validation", {
                            attrs: { field: "expiration_month" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var bind = ref.bind
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-select",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            ref: "exp_month",
                                            attrs: {
                                              label: "MM",
                                              items: _vm.available_months,
                                              dense: "",
                                              "menu-props": {
                                                auto: true,
                                                offsetY: true,
                                                contentClass: "big-menu"
                                              }
                                            }
                                          },
                                          "v-select",
                                          bind,
                                          false
                                        ),
                                        on
                                      )
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("with-validation", {
                            attrs: { field: "expiration_year" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var bind = ref.bind
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-select",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            ref: "exp_year",
                                            attrs: {
                                              label: "YY",
                                              items: _vm.available_years,
                                              dense: "",
                                              "menu-props": {
                                                auto: true,
                                                offsetY: true,
                                                contentClass: "big-menu"
                                              }
                                            }
                                          },
                                          "v-select",
                                          bind,
                                          false
                                        ),
                                        on
                                      )
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "d-flex flex-row" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "desktop-block d-flex justify-content-center",
                              staticStyle: {
                                "padding-bottom": "25px",
                                "flex-basis": "0",
                                "flex-grow": "1"
                              }
                            },
                            [
                              _c("v-divider", {
                                staticClass: "mx-4",
                                attrs: { vertical: "" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("with-validation", {
                            attrs: { field: "cvv" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var bind = ref.bind
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-text-field",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            directives: [
                                              {
                                                name: "mask",
                                                rawName: "v-mask",
                                                value: "####",
                                                expression: "'####'"
                                              }
                                            ],
                                            staticStyle: {
                                              "flex-basis": "100px",
                                              "flex-grow": "0"
                                            },
                                            attrs: {
                                              dense: "",
                                              outlined: "",
                                              label: "cvv",
                                              type: "text"
                                            }
                                          },
                                          "v-text-field",
                                          bind,
                                          false
                                        ),
                                        on
                                      )
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c("with-validation", {
            attrs: { field: "agreement" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var bind = ref.bind
                  var on = ref.on
                  return [
                    _c(
                      "v-checkbox",
                      _vm._g(
                        _vm._b(
                          {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        "\n                        I have read and agree to the\n                         "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.ui__openModalByName({
                                                name: "dialog_terms"
                                              })
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.terms_and_conditions_title
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                        ,\n                         "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.ui__openModalByName({
                                                name: "dialog_privacy_policy"
                                              })
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.privacy_policy_title)
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        " \n                        and\n                         "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.ui__openModalByName({
                                                name:
                                                  "dialog_cancelation_policy"
                                              })
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.cancellation_policy_title
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            )
                          },
                          "v-checkbox",
                          bind,
                          false
                        ),
                        on
                      )
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }